import {
  BaseDialPadButtonContent,
  keyboardSymbols,
} from 'features/dial-pad/constants';
import { DialPadButtonValue } from 'features/dial-pad/enums';

const allowedDialPadValues = [
  ...keyboardSymbols,
  BaseDialPadButtonContent[DialPadButtonValue.Asterisk].value,
  BaseDialPadButtonContent[DialPadButtonValue.Hash].value,
];

export const getIsAllowedDialPadValue = (value: string) =>
  allowedDialPadValues.includes(value);
